var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feather-map-pin",
    "data-name": "Icon feather-map-pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.229,
    height: 21.057,
    viewBox: "0 0 17.229 21.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M21.729,10.114c0,6.7-8.614,12.443-8.614,12.443S4.5,16.814,4.5,10.114a8.614,8.614,0,1,1,17.229,0Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#3e3e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M19.243,13.371A2.871,2.871,0,1,1,16.371,10.5a2.871,2.871,0,0,1,2.871,2.871Z",
    transform: "translate(-7.757 -4.757)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconBlack);
export default __webpack_public_path__ + "static/media/locationIconBlack.6928773ce255fab5b2253ce459bdb394.svg";
export { ForwardRef as ReactComponent };